<template>
    <entity-panel :id="id" :panel-entity="panelEntity"></entity-panel>
</template>

<script>
export default {
    name: 'QuizPanelView',
    props: { id: String },
    computed: {
        panelEntity() {
            return this.$constants.entities.Quiz;
        }
    }
};
</script>
